import { createHeading } from 'common/client/helpers/block-helpers'

import { layout } from 'thewest/App.routing'
import { createDiagExample } from 'component-library/diagnostics/createDiagExample'
import { errorRoutesList } from 'component-library/diagnostics/error-routes'
import { BaseClientConfig } from 'common/client/BaseClientConfig'
import { PageType, createPageDefinition } from 'common/routing/page-definition'
import { noIndexMeta } from 'common/meta/common-tags'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'
import { ListBlock } from 'common/client-data-types/blocks'

export interface StaticRoutesWithInfo {
    [key: string]: PageType<typeof layout, TheWestSection>
}

const fatwireRedirectRoute = createDiagExample(
    '/business/reality-bites-naive-hopefuls/story-e6frg2t3-1111112598276',
    'Example of an old fatwire publication url'
)

const newsCorpRedirectRoute = createDiagExample(
    '/news/western-australia/irukandji-jellyfish-warning-for-visitors-to-was-ningaloo-reef/news-story/e9f2263e36907415115ead7a72e93df1',
    'Example of an old news corp publication url'
)

const httpRedirectRoute = (config: BaseClientConfig) =>
    createDiagExample(
        `http://${config.publicHostname}/news/wa/article-with-images-containing-only-1-crop-ng-b88453367z`,
        'Example of an newsgate publication url with http (only redirects behind akamai)'
    )

const ampRedirectRoute = (config: BaseClientConfig) =>
    createDiagExample(
        `http://amp.${config.publicHostname}/politics/pm-meeting-trump-on-asia-summit-sidelines-ng-s-1796932`,
        'Example of an amp redirect'
    )

const trailingSlashRedirectRoute = createDiagExample(
    `/news/`,
    'Example of an trailing slash redirect'
)

const redirectList = (config: BaseClientConfig): ListBlock => ({
    kind: 'ordered-list',
    items: [
        fatwireRedirectRoute,
        httpRedirectRoute(config),
        newsCorpRedirectRoute,
        ampRedirectRoute(config),
        trailingSlashRedirectRoute,
    ],
})

const adTargetingRoute = createDiagExample(
    `/diag/ad-targeting`,
    'Ad Targeting for our static routes'
)

const adList: ListBlock = {
    kind: 'ordered-list',
    items: [adTargetingRoute],
}

export function createDiagPage(config: BaseClientConfig, section: TheWestSection) {
    return createPageDefinition<typeof layout, TheWestSection>(
        {
            heading: 'Diag Routes overview',
            hideHeading: true,
            pageType: 'static',
            adTargeting: {
                pageId: 'diag',
                adUnitPath: '',
                ssAdUnits: [],
                topics: [],
            },
            pageMeta: {
                meta: [noIndexMeta],
            },
            section,
        },
        layout.composition({
            type: 'thor',
            props: {},
            contentAreas: {
                main: [
                    {
                        type: 'breadcrumb',
                        props: {
                            title: 'Diag Routes overview',
                            enableHeaderTag: true,
                        },
                    },
                    layout.component({
                        type: 'inline-content',
                        props: {
                            blocks: [
                                ...errorRoutesList,
                                ...(section === 'default' ? [createHeading('Redirects')] : []),
                                ...(section === 'default' ? [redirectList(config)] : []),
                                ...(section === 'default' ? [createHeading('Ads')] : []),
                                ...(section === 'default' ? [adList] : []),
                            ],
                        },
                    }),
                ],
            },
        })
    )
}
